export type DeliveryRouteRejectedReason =
  | 'MATERIAL_CONTROL'
  | 'TRANSPORT_REQUIREMENT'
  | 'NO_OPEN_TRIP'
  | 'WINDOW_CONFLICT'
  | 'NO_TRIP_IN_WINDOW'
  | 'HOLIDAY';

export type DeliveryWindowSource = 'ITEM' | 'MATERIAL_LIST' | 'CUSTOMER' | 'SUB_ROUTE' | 'DEFAULT';

export interface DeliveryRouteRequest {
  shipToId: string;
  companyId: string;
  documentDate: string; // YYYY-MM-DD
  materialIds?: string[];
  documents?: DeliveryRouteDocumentRequest[]; // reparto ya calculado, una resolución por documento
}

export interface DeliveryRouteDocumentRequest {
  index: number;
  materialIds: string[];
}

// artículo que impidió usar la ruta, con el dato que lo bloqueó
export interface BlockingMaterial {
  _id: string;
  code: string;
  name: string;
  windowSource?: DeliveryWindowSource;
  days?: number[];
  hourStart?: string;
  hourEnd?: string;
  missingRequirements?: { _id: string; name: string }[];
}

export interface DeliveryRouteTrip {
  _id: string;
  id: number;
  externalKeys?: any;
  description?: string;
  loadDateTime: string | null;
  dateHourStartTeoric: string | null;
  dateHourEndTeoric: string | null;
}

// ventana resultante de cruzar todos los artículos; es contra la que se mide el viaje
export interface EffectiveWindow {
  days: number[];
  hourStart: string;
  hourEnd: string;
  hoursToDelivery: number;
  restrictedBy: { _id: string; code: string; name: string }[];
}

// ventana efectiva de un artículo; con esto se agrupa y se parte el pedido
export interface MaterialDeliveryWindow {
  _id: string;
  code: string;
  name: string;
  windowSource: DeliveryWindowSource;
  days: number[];
  hourStart: string;
  hourEnd: string;
  hoursToDelivery: number;
}

export interface DeliveryRouteCandidate {
  _id: string;
  id: number;
  name: string;
  externalKeys?: any;
  model: string;
  type: string;
  routes: any[];
  trip: DeliveryRouteTrip | null;
  alternativeTrips: DeliveryRouteTrip[];
  rejectedTrips: DeliveryRouteTrip[]; // viajes que existían pero no sirvieron
  effectiveWindow: EffectiveWindow | null;
  skippedHolidays: string[];
  eligible: boolean;
  rejectedReason: DeliveryRouteRejectedReason | null;
  blockingMaterials: BlockingMaterial[];
  windowConflict?: boolean;
  materialWindows?: MaterialDeliveryWindow[];
  estimatedDeliveryDate?: string | null;
}

export interface DeliveryRouteResolution {
  routes: DeliveryRouteCandidate[];
  selectedRouteId: string | null;
  tiedRouteIds: string[];
  // los artículos no comparten día ni franja: el documento hay que partirlo
  windowConflict?: boolean;
  materialWindows?: MaterialDeliveryWindow[];
  estimatedDeliveryDate?: string | null;
  documents?: DeliveryRouteDocumentResolution[]; // presente solo si la petición llevó reparto
}

export interface DeliveryRouteDocumentResolution {
  index: number;
  routes: DeliveryRouteCandidate[];
  selectedRouteId: string | null;
  tiedRouteIds: string[];
  windowConflict?: boolean;
  materialWindows?: MaterialDeliveryWindow[];
  estimatedDeliveryDate?: string | null;
}

// Translation KEYS, not text. A module-level constant is evaluated at import time, before the
// language is resolved, so holding translated strings here would freeze whatever was active then
// and never follow a language switch. Every call site resolves these through LanguageService.

// completan la frase del encabezado "Horario de entrega definido en"
export const DELIVERY_WINDOW_SOURCE_LABEL_KEYS: Record<DeliveryWindowSource, string> = {
  ITEM: 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.WINDOW_SOURCE_ITEM',
  MATERIAL_LIST: 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.WINDOW_SOURCE_MATERIAL_LIST',
  CUSTOMER: 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.WINDOW_SOURCE_CUSTOMER',
  SUB_ROUTE: 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.WINDOW_SOURCE_SUB_ROUTE',
  DEFAULT: 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.WINDOW_SOURCE_DEFAULT',
};

export const DELIVERY_ROUTE_REJECTED_LABEL_KEYS: Record<DeliveryRouteRejectedReason, string> = {
  MATERIAL_CONTROL: 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.REJECTED_MATERIAL_CONTROL',
  TRANSPORT_REQUIREMENT: 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.REJECTED_TRANSPORT_REQUIREMENT',
  NO_OPEN_TRIP: 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.REJECTED_NO_OPEN_TRIP',
  WINDOW_CONFLICT: 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.REJECTED_WINDOW_CONFLICT',
  NO_TRIP_IN_WINDOW: 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.REJECTED_NO_TRIP_IN_WINDOW',
  HOLIDAY: 'DOCUMENT_GENERATE.DELIVERY_ROUTE_MODAL.REJECTED_HOLIDAY',
};
